import { render, staticRenderFns } from "./ArrowNext2.vue?vue&type=template&id=66b795bb&scoped=true&"
var script = {}
import style0 from "./ArrowNext2.vue?vue&type=style&index=0&id=66b795bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b795bb",
  null
  
)

export default component.exports